import { render, staticRenderFns } from "./NotificationsManagement.vue?vue&type=template&id=efb8cfb6"
import script from "./NotificationsManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsManagement.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports